import {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';

import {appConfig} from '@stencil/hotels-config';

import RoomPerNightUI from '../../../../../../../../stories/components/hotels/DetailsPageUnif/RoomPerNightUI/RoomPerNightUI';
import CheckAvailabilityBtnUI from '../../../../../../../../stories/components/hotels/DetailsPageUnif/CheckAvailabilityAltAcco/CheckAvailabilityBtnUI';

import * as S from './RecommendedComboList.style';
import {getSlashAndShowPriceCg} from '@stencil/hotels-utils/src/get-details-slash-and-show-price';
import useCurrentRoomData from '../../../../../../../hooks/useCurrentRoomData';
import {
  isEntirePropertySelector,
  stayTypeSelector,
  isAltAccoUrlPropsSelector,
  entirePropertyMergedTypeSelector,
} from '@stencil/hotels-cg-reducer/src/details/selectors';
import {isDatePickRequiredSelector} from '@stencil/hotels-common-reducer/src/selectors';
import {rupeeString} from '@stencil/hotels-config/src/config/app-config';

interface RecommendedComboPriceProps {
  repriceRequestObj?: any;
  repricePax: number;
  roomData: any;
  comboData: any;
  defaultPriceKey: string;
  comboTariff: any;
  onSelectClick: () => void;
  sellableType?: string;
}

export default function RecommendedComboPrice({
  roomData,
  comboTariff,
  onSelectClick = () => {},
  handlOpenCalendar = () => {},
  sellableType = '',
}) {
  const isEntireProperty = useSelector(isEntirePropertySelector);
  const stayType = useSelector(stayTypeSelector);
  const mergedPropType = useSelector(entirePropertyMergedTypeSelector);
  const {activeBankCode} = useCurrentRoomData();
  const [priceInfo, setPriceInfo] = useState({});
  const isDatePickRequired = useSelector(isDatePickRequiredSelector);
  const isAltAccoUrlProps = useSelector(isAltAccoUrlPropsSelector);

  useEffect(() => {
    const {slashedPrice, showPrice, payAtPersuasionShowPrice, tnc, priceDisplayMsg} =
      getSlashAndShowPriceCg(comboTariff, activeBankCode);
    setPriceInfo({
      slashedPrice,
      showPrice,
      payAtPersuasionShowPrice,
      tnc,
      priceDisplayMsg,
    });
  }, [activeBankCode]);
  const onSelectComboClick = () => {
    onSelectClick();
  };
  return (
    <>
      {priceInfo?.slashedPrice ? (
        <S.StrickedPricePara>
          {rupeeString} {priceInfo?.slashedPrice}
        </S.StrickedPricePara>
      ) : null}
      <S.OriginalPricePara>
        {rupeeString} {priceInfo?.showPrice}
      </S.OriginalPricePara>
      {!!priceInfo?.tnc && (
        <S.TaxInclusionPara>
          {' '}
          + {rupeeString} {priceInfo?.tnc} taxes & fees{' '}
        </S.TaxInclusionPara>
      )}

      <S.RoomsAvailablePara>
        <RoomPerNightUI
          roomCount={isEntireProperty ? '' : comboTariff?.occupancydetails?.roomCount}
          roomText={!!mergedPropType ? mergedPropType : sellableType}
        />
      </S.RoomsAvailablePara>
      {isAltAccoUrlProps && isDatePickRequired ? (
        <CheckAvailabilityBtnUI handlOpenCalendar={handlOpenCalendar} />
      ) : (
        <S.ComboBtn onClick={() => onSelectComboClick()}>SELECT COMBO</S.ComboBtn>
      )}
    </>
  );
}
